import React from "react";

// styles
import colors from "core/colors";
import { OpeningTextStyled, H2Styled } from "./styles";

// components
import BodyText from "core/BodyText";
import Link from "core/Link";

const OpeningText = () => {
    return (
        <OpeningTextStyled>
            <H2Styled size={16}>You must attribute the artist</H2Styled>
            <BodyText type="p" size="lg" copyColor={colors.primary.diamond}>
                Insert the link below for digital uses.{" "}
                <Link
                    href="https://help.thenounproject.com/hc/en-us/articles/360053641314-How-do-I-credit-a-creator-"
                    target="_blank"
                    darkMode
                >
                    {" "}
                    More Info
                </Link>
            </BodyText>
        </OpeningTextStyled>
    );
};

export default OpeningText;
